import { IHeaderParams } from 'ag-grid-community';
import clsx from 'clsx';

import { SVGIcon } from '../../icons/SVGIcon';

import styles from './customHeader.module.scss';

export type CustomSortModelItem = {
  /** Column field (key) to apply the sort to. */
  key: string;
  /** Sort direction */
  sort: 'asc' | 'desc';
};

export interface ICustomHeaderParams extends IHeaderParams {
  onSortingChanged: (sortItem: CustomSortModelItem) => void;
  sortItems?: CustomSortModelItem[];
  sublabel?: string;
}

export const CustomHeader = ({
  column,
  displayName,
  enableSorting,
  onSortingChanged,
  sortItems,
  sublabel,
}: ICustomHeaderParams) => {
  if (column.getColId() === 'ag-Grid-SelectionColumn') {
    return null;
  }

  const sortDirection = enableSorting
    ? sortItems?.find(
        (sortItem) =>
          sortItem.key === (column.getColDef().field ?? column.getColId())
      )?.sort
    : undefined;
  const headerClass = column.getColDef()?.headerClass;

  const renderSortingIcon = () => {
    return (
      <div className={styles['sort-icon']}>
        {sortDirection === 'asc' && <SVGIcon name="sorting-asc" />}
        {sortDirection === 'desc' && <SVGIcon name="sorting-desc" />}
        {sortDirection == null && <SVGIcon name="sorting-non" />}
      </div>
    );
  };

  return (
    <div
      className={clsx(styles['root'], {
        [styles['root--sortable']]: enableSorting,
      })}
      onClick={
        enableSorting
          ? () =>
              onSortingChanged({
                key: column.getColDef().field ?? column.getColId(),
                sort: sortDirection === 'asc' ? 'desc' : 'asc',
              })
          : undefined
      }
    >
      <div className={clsx(styles['label'], headerClass)}>
        {displayName}
        {sublabel && <div className={clsx(styles['sublabel'])}>{sublabel}</div>}
      </div>
      {enableSorting && renderSortingIcon()}
    </div>
  );
};
